import React, {FC} from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';
import './App.css';
import EventPage from './components/EventPage/EventPage';
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from '@apollo/client';
import {ApolloProvider} from '@apollo/client/react';
import {SetContextLink} from '@apollo/client/link/context';

import {Box, ThemeProvider, createTheme} from '@mui/material';
import {cyan} from '@mui/material/colors';
import {DESKTOP_MIN_WIDTH} from './components/EventPage/layout';
import logo from './livezone_logo.png?inline';

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_GRAPHQL
});

const authLink = new SetContextLink((prevContext) => {
  const accessToken = localStorage.getItem('access_token');
  return {
    headers: {
      ...prevContext.headers,
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    }
  };
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache()
});

const defaultTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: DESKTOP_MIN_WIDTH,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    primary: {
      main: '#ff0066'
    },
    secondary: {
      main: cyan[500]
    }
  },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    button: {
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 10
  }
});

const App: FC = () => {
  const routes = [
    {
      path: '/',
      element: (
        <Box className="event-shell" sx={{ alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ height: 'auto', px: 5, py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box component="img" src={logo} alt="LiveZone" sx={{ height: 36 }} />
            <Box sx={{ color: '#6b7280', fontWeight: 600 }}>Open an event link to follow the race.</Box>
          </Box>
        </Box>
      )
    },
    {
      path: '/:slug',
      element: <EventPage />
    },
    {
      path: '/:slug/:sub',
      element: <EventPage />
    }
  ];
  const router = createBrowserRouter(routes);

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={defaultTheme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
